export default __webpack_public_path__ + "static/media/maor-shop-2.ff638678.png";